// src/screens/Auth/LoginScreen.js
import React, { useState } from 'react';
import { useAuth } from '../../AuthContext.js';

export default function LoginScreen() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!username.trim() || !password.trim()) {
      setError('Please enter both username and password.');
      return;
    }
    try {
      await login(username.trim(), password.trim());
    } catch (err) {
      setError(err.message || 'Invalid username or password');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="p-6 max-w-sm mx-auto bg-white rounded-2xl shadow-lg">
      <h2 className="text-2xl font-bold text-center mb-4">Sign In</h2>
      {error && <div className="text-red-600 mb-4">{error}</div>}

      <label className="block mb-1">Username</label>
      <input
        type="text"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        className="border rounded p-2 w-full mb-4"
        placeholder="Username"
      />

      <label className="block mb-1">Password</label>
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="border rounded p-2 w-full mb-6"
        placeholder="Password"
      />

      <button type="submit" className="w-full px-4 py-2 bg-blue-600 text-white rounded">
        Sign In
      </button>
    </form>
  );
}
